import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
export const addOrEditCoupon = (params, isEdit) => {
  params.businessType = 0;
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/coupon`,
    method: isEdit ? "PUT" : "POST",
    data: params,
  });
};
export const delCoupon = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/coupon/${ids}`,
    method: "DELETE",
  });
};
// 获取列表
export const getCouponList = (params) => {
  params.businessType = 0;
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/coupon?` + params,
    method: "GET",
  });
};
// 获取详情
export const getCouponDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/coupon/${id}`,
    method: "GET",
  });
};
//获取产品列表
export const getGoodsList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods?` + params,
    method: "GET",
  });
};
// 入库
export const increaseGoods = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods`,
    method: "POST",
    data: params,
  });
};
// 获取产品详情列表
export const getGoodsDetailList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods/goods?` + params,
    method: "GET",
  });
};
// 获取入库详情列表
export const getCouponEntryDetailList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods/detailed?` + params,
    method: "GET",
  });
};
// 删除产品详情
export const delDetailGoods = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods/${ids}`,
    method: "DELETE",
  });
};
// 发放优惠券
export const sendCoupon = (id, params) => {
  // params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/coupon/grant/${id}?clientType=JOINS_MERCHANT`,
    method: "PUT",
    data: params.merchant,
  });
};
// 一键发放优惠券
export const oneClickGrant = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/coupon/oneClickGrant/${id}`,
    method: "PUT",
  });
};
// 获取发放记录
export const getSendRecord = (id, params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/coupon/shop-list/${id}?${params}`,
    method: "GET",
  });
};
// 删除发放记录
export const delCouponSendRecord = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/coupon/delete/${ids}`,
    method: "DELETE",
  });
};
